export const barchartIcon = [
  "24 24",
  `     
    <path xmlns="http://www.w3.org/2000/svg" fill="none" stroke="" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M18,20V10 M12,20V4 M6,20
	v-6"/>
          
            `,
];
